import React from 'react';

import {
    RIQInfoPopover
} from '../../../components/RIQPopover.jsx';


export default function QueryValidationError({searchTermsError, searchTermsWarning}) {
    return (
        <>
            {searchTermsError &&
                <div className='tlw-w-full tlw-px-2 tlw-text-sm tlw-text-red-500'>
                    {searchTermsError?.message || ''}
                    {searchTermsError?.additionalInfo &&
                        <RIQInfoPopover
                            description={searchTermsError.additionalInfo}
                        />
                    }
                </div>
            }

            {!searchTermsError && searchTermsWarning &&
                <div>
                    <span className='fa fa-warning' />
                    <span className='tlw-w-full tlw-px-2 tlw-text-sm'>
                        {searchTermsWarning?.message || ''}
                        {searchTermsWarning?.additionalInfo &&
                            <RIQInfoPopover
                                description={searchTermsWarning.additionalInfo}
                            />
                        }
                    </span>
                </div>
            }
        </>

    );
}
